import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Background from 'components/common/Background';
import Avatar from 'components/common/Avatar';
import classNames from 'classnames';
import GoogleMap from 'components/map/GoogleMap';
import Logo from '../../../assets/img/illustrations/guardnetbase.png';
import Iframe from 'react-iframe'

const ProfileBannerHeader = ({ avatar, coverSrc, className }) => {
  return (
    <Card.Header
      className={classNames(className, 'position-relative min-vh-25 mb-7')}
    >
      <Iframe url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3014.586552305862!2d29.152828776036372!3d40.924810371362376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac54aa29a8ff9%3A0x3d389d1ea1adfae3!2zw5Z6Z8O8bCBwbGF6YQ!5e0!3m2!1str!2str!4v1697975841106!5m2!1str!2str"
        width="100%"
        height="350px"
        id=""
        className=""
        display="block"
        position="relative"/>
      <Avatar
        size="5xl"
        className="avatar-profile img-fluid"
        src={Logo}
        mediaClass="img-thumbnail shadow-sm contain"
      />
    </Card.Header>
  );
};

const ProfileBannerBody = ({ children }) => {
  return <Card.Body>{children}</Card.Body>;
};

const ProfileBanner = ({ children }) => {
  return <Card >{children}</Card>;
};

ProfileBanner.Header = ProfileBannerHeader;
ProfileBanner.Body = ProfileBannerBody;

ProfileBannerHeader.propTypes = {
  avatar: PropTypes.string.isRequired,
  coverSrc: PropTypes.string.isRequired,
  className: PropTypes.string
};

ProfileBannerBody.propTypes = {
  children: PropTypes.node.isRequired
};

ProfileBanner.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProfileBanner;
